import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	openKey: "",
	selectedKey: "",
	theme: "dark",
	user: {
		permissions: [],
	},
};

export const appSlice = createSlice({
	name: "app",
	initialState,
	reducers: {
		openMenu: (state, action) => {
			state.openKey = action.payload;
		},
		setRoute: (state, action) => {
			state.openKey = action.payload.openKey;
			state.selectedKey = action.payload.selectedKey;
		},
		updateSettings: (state, action) => {
			state.settings = action.payload;
		},
		updateTheme: (state, action) => {
			state.theme = action.payload;
		},
		updateUser: (state, action) => {
			state.user = action.payload;
		},
	},
});

export const { openMenu, setRoute, updateSettings, updateTheme, updateUser } =
	appSlice.actions;

export default appSlice.reducer;
